export default {
  main: {
    // 文件
    fileTitle: "名称",
    fileSize: "大小",
    fileDate: "修改时间",
    InquiryId: "询盘ID",
    country: "国家",
    client: "客户",
    sales: "销售",
    date: "日期",
    inquiry: "询盘",
    order: "订单",
    sipping: "发货",
    pay: "支付",
    user: "用户",
    type: "类型",
    clientGrade: "客户等级",
    retail: "零售/批发",
    customer: "顾客",
    sell: "销售",
    status: "状态",
    operator: "操作人",
    myFiles: "我的文件",
    FileSharing: "文件分享",
    fileName: "文件名",
    password: "密码",
    noPassword: "无需密码",
    yesPassword: "通过密码分享",
    expirationTime: "到期时间",
    cancel: "取消",
    define: "确定",
    interlinkage: "链 接",
    extractCode: "提取码",
    createLink: "创建链接",
    copyAndClose: "复制并关闭",
    newFolder: "新建文件夹",
    picturePreview: "图片预览",
    oneHour: "一小时过期",
    oneWeek: "一周过期",
    oneMonth: "一个月过期",
    halfAYear: "半年过期",
    aYear: "一年过期",
    newBuilt: "新建",
    download: "下载",
    delete: "删除",
    share: "分享",
    rename: "重命名",

    pleaseChoose: "请选择",
    pleaseFillIn: "请填写",

    /****order Sales****/
    SalesOrder: "销售单",
    SorderList: "订单列表",
    SorderSeachName: "输入客户姓名",
    SorderListSodrderID: "订单号",
    SorderListState: "订单状态",
    SorderListItems: "产品数",
    SorderListCity: "城市",
    SearchCustomersOrders: "查询客户订单",
    SorderSalesTeam: "团队人员",
    // 信息选择
    SorderTeam: "团队",
    SorderListClient: "客户",
    SorderListPleaseSelectClient: "请选择客户",
    SorderListAddress: "地址",
    SorderListSupplier: "供应商",
    SorderListPleaseSelectSupplier: "请选择供应商",
    SorderListDAddress: "交货地址",
    SorderListWholesale: "批发",
    SorderListRetail: "零售",
    SorderListPayment: "支付",
    SorderListPleaseSelectBank: "请选择银行",
    SorderListPleaseSelectCurrency: "请选择货币类型",
    SorderListPleaseSelectOrder: "请选择订单",
    // 弹窗按钮
    SorderListNewOrder: "新建订单",
    SorderListSave: "保存",
    SorderListCopyformOrder: "从订单复制",
    SorderListFromRFQ: "从询盘添加",
    SorderListFromQuotation: "从报价添加",
    SorderListClearance: "清关信息",
    SorderListDelete: "删除订单",
    SorderListPlaceanorder: "订购产品",
    SorderListDeliverGoods: "产品发货",
    SorderListExport: "导出订单",
    SorderListCost: "采购记录",
    SorderListShipping: "发货记录",
    SorderEntryRecord: "付款记录",
    // 详情
    SorderListDetailModel: "产品型号",
    SorderListDetailBrand: "品牌",
    SorderListDetailDescription: "产品描述",
    SorderListDetailState: "状态",
    SorderListDetailWeight: "重量",
    SorderListDetailQty: "数量",
    SorderListDetailPrice: "价格",
    SorderListDetailProfit: "利润",
    SorderListDetailCost: "成本",
    SorderListDetailLeading: "交期",
    SorderListDetailCondition: "货况",
    SorderListDetailRelaredDoc: "相关文档",
    SorderListDetailOperation: "操作",
    SorderListDetailCreateTime: "创建时间",
    SorderListDetailDelete: "删除产品",
    //底部
    SorderListFooterDiscount: "订单折扣",
    SorderLitFooterShippingCost: "航运费用",
    SorderListFooterPaymentFee: "手续费用",
    SorderListFooterVat: "关税费用",
    SorderListFooterSubtal: "商品总价",
    SorderListFooterTotal: "订单总价",
    SOrderListFooterPaymentReceived: "收到货款",
    SorderListFooterCost: "订单成本",
    // 图表
    SorderListChartPurchase: "采购价",
    SorderListChartSales: "销售价",
    SorderListChartMon: "周一",
    SorderListChartTue: "周二",
    SorderListChartWed: "周三",
    SorderListChartThu: "周四",
    SorderListChartFri: "周五",
    SorderListChartSat: "周六",
    SorderListChartSun: "周日",
    // 弹窗组件
    SorderListCopyModelToOrder: "复制产品到订单",
    SorderListCopy: "复制",
    SorderListAdd: "添加",
    SorderListAddModelToOrder: "添加产品到订单",
    SorderListPleaseEnterRfqID: "请输入询盘ID",
    SorderListTotalAmount: "总金额",
    SorderListDeclareAmount: "申报金额",
    SorderListDeclareName: "申报产品名",
    SorderListDeclareInfo: "申报信息",
    SorderListDeclarePrice: "申报价格",
    SorderListFullOrder: "全部订货",
    SorderListPartialOrder: "部分订货",
    SorderListDetailHQty: "已订货数量",
    SorderListDetailPQty: "部分订货数量",
    SorderListPleaseQuantity: "请输入产品数量",
    SorderListPurchaser: "采购",
    SorderListFullDelivery: "全部发货",
    SorderListPartialDelivery: "部分发货",
    SorderListSQty: "已发货数量",
    SorderListPqty: "部分发货数量",
    SorederListExport: "导出",
    SorderListScheduledGoods: "预订货",
    SorderListExitNewOrder: "退出新建",
    // order Puchase
    PurchaseOrder: "采购单",
    PurchaseOrderPurchase: "选择采购",
    PurchaseOrderTakeList: "采购任务列表",
    PurchaseOrderTakeListPtaskID: "任务单号",
    PurchaseOrderTakeListState: "状态",
    PurchaseOrderTakeListSales: "销售",
    PurchaseOrderTakeListPurchase: "采购",
    PurchaseOrderTakeListPurchase1: "选择采购",
    PurchaseOrderTakeListCreationTime: "创建时间",
    PurchaseOrderTakeDetailDQty: "待采购数",
    PurchaseOrderTakeDetailFqty: "分配数",
    PurchaseOrderTakeDetailInventory: "库存",
    PurchaseOrderTakeDetailAvailable: "可用库存",
    PurchaseOrderTakeDetailOccupy: "占用库存",
    PurchaseOrderTaleDetailreturnTask: "退回任务",
    PurchaseOrderList: "采购单列表",
    PurchaseOrderListPorderID: "采购单号",
    PurchaseOrderListSupplier: "供应商",
    PurchaseOrderListFounder: "创建者",
    PurchaseOrderListDetailTotal: "总价",
    PurchaseOrderListDetailPqty: "采购数量",
    PurchaseOrderListDetailPrice: "采购价",
    PurchaseOrderButtonNew: "新增采购单",
    PurchaseOrderButtonAssignTasks: "调配任务",
    PurchaseOrderButtonSubmitTask: "提交任务",
    PurchaseOrderButtonDelete: "删除任务",
    PurchaseOrderButtonChangePrice: "更改价格",
    PurchaseOrderBUttonSubmitPrice: "提交价格",
    PurchaseOrderButtonExport: "导出采购单",
    PurchaseOrderButtonDel: "删除采购单",
    PurchaseOrderNewPurchaseOrder: "新建采购单",
    PurchaseOrderSelectSupplier: "选择供应商",
    PurchaseOrderNonStock: "非库存",
    PurchaseOrderNewPqty: "采购数",
    PurchaseOrderNewCost: "采购价",
    PurchaseOrdernewAvailableQty: "走库房数",
    PurchaseOrderNewAvailablePrice: "库房价格",
    PurchaseOrderNewInventoryPrift: "库房利润",
    PurchaseOrderExportRate: "汇率",
    PurchaseOrderExportSprice: "销售价",
    PurchaseOrderExportAmountProfit: "利润金额",
    PurchaseOrderExportAmount: "总金额",
    PurchaseOrderExportNumber: "序号",
    PurchaseOrdering: "采购中",
    PurchaseCommission: "加入提成",
  },
  //消息模块
  message: {
    Mymessage: "我的消息",
    MessageSettings: "消息设置",
    Read: "已读",
    newTemplate: "创建消息模板",
    OrderMessage: "工单消息",
    SystemMessages: "系统消息",
    EventType: "事件类型",
    ContentTemplate: "内容模板",
    MessageContent: "消息内容",
    state: "状态",
    PushMethod: "推送方式",
    PushTime: "推送时间",
    PushNow: "立即推送",
    exceed: "超过",
    HourlyPush: "小时推送",
    founder: "创建人",
    priority: "优先级",
    ordinary: "普通",
    emergent: "紧急",
    ReceptionTime: "接收时间",
    Creationtime: "创建时间",
    operate: "操作",
    WorkOrder: "查看工单",
    edit: "编辑",
    Enable: "启用",
    Deactivate: "停用",
    Enabled: "启用",
    Disabled: "停用",
    editTemplate: "编辑消息模板",
    save: "保存",
    messageType: "消息类型",
    MessageTemplate: "消息模板",
    cancellation: "取消",
    EnableStatus: "启用状态",
    sitePush: "站内推送",
    textMmessage: "短信",
    orderExceeds: "工单超过",
    orderContent: "小时未解决，推送消息提醒",
    interval: "间隔",
    Pushonceperhour: "小时推送一次",
    PushObject: "推送对象",
    Receiver: "接单人",
    promoter: "发起人",
    CcTo: "抄送人",
    OrderDetails: "工单详情",
    close: "关闭",
    ToHandle: "去处理",
    InitiateWorkOrder: "发起工单",
    source: "来源",
    describe: "描述",
    loading: "加载更多",
    notExist: "工单已删除",

    AllTypes: "全部类型",
    AllRead: "全部已读",
    Messages: "消息",
    enabledSuccessfully: '模板启用成功',
    disabledSuccessfully: '模板禁用成功',
    SaveSuccessfully: '保存成功',
    Type: '类型',
    KeyWords: '关键词',
    EnabledTitle: '你确定要启用它吗?',
    DisabledTitle: '你确定要停用它吗?',
    EventTypeRule: '请选择事件类型',
    ContentRule: '内容不能为空',
    PushTimeRule: '请选择推送时间',
    PushObjectRule: '请选择推送对象',
    PushMethodRule: '请选择推送方式',

  },
  //订单
  Order: {
    OrderAll: '所有',
    OrderMy: '我的',
    salesOrder: '销售单',
    salesOrder1: '销售单',
    salesOrder2: '佣金单',
    salesOrder3: '售后补发单',
    sOrderTypeWholesale: '批发',
    sOrderTypeRetail: '零售',
    sOrderTypecommission: '佣金单',
    sOrderAllstatus: '全部状态',
    sOrderStateTobestarted: '待开始',
    sOrderStateUnderway: '进行中',
    sOrderStateCompleted: '已完成',
    sOrderStateAllocationorder: '待分配订货',
    sOrderStateOnassignment: '待分配发货',
    sOrderStateGeneraldelivery: '待总务发货',
    sOrderStateLogisticsdocumentary: '待物流跟单',
    sOrderStateIncoming: '待核对到货',
    SorederListExport: "导出",

    pOrderStateTobepurchased: '待采购',
    pOrderStateInprocurement: '采购中',
    pOrderStatePurchasecompleted: '采购完成',
    pOrderStateTobepaid: '待付款',
    pOrderStatePaid: '已付款',
    pOrderStateWaitingforarrival: '到货中',
    pOrderStatePurchasecompleted: '采购完成',
    pOrderIndex: '序号',
    PurchaseOrderPOID: '采购单号',
    PurchaseOrderTotal: '总价',
    PurchaseOrderProfit: "利润金额",

    OrderNew: '新建',
    OrderFromOrder: '来自订单',
    OrderFromRFQ: '来自询盘',
    OrderFromQTN: '来自报价',
    OrderClearance: '清关信息',
    OrderPlaceanorder: "分配订货",
    OrderDeliver: "分配发货",
    OrderListCost: "采购记录",
    OrderListShipment: "发货记录",
    OrderExtraSearch: '精确搜索',
    OrderSettle: '订单结算',
    OrderSettlementDetails: '订单结算明细',


    OrderOwner: '责任人',
    OrderSOID: '订单号',
    OrderCarrier: '运输',
    OrderCreator: '创建人',
    OrderSubject: '主题',
    OrderTableContact: '联系人',
    OrderTableCountry: '国家/地区',
    OrderTableItems: '项目',
    OrderTableType: '类型',
    OrderTableSales: '销售',
    OrderTableStatus: '状态',
    OrderTableCreatedDate: '创建日期',

    OrderCreated: '创建',
    OrderApprove: '批准',
    OrderTraded: '已送达',
    OrderStateCancel: '取消',
    OrderAllStatus: '全部状态',
    OrderAllType: '全部类型',
    OrderAllVendor: '全部供应商',
    OrderAllContatc: '全部联系人',
    OrderAllCountries: '全部国家',
    OrderAllModels: '全部产品',
    OrderPurchaseOrder: '采购单',

    OrderTableModel: "产品型号",
    OrderTableBrand: "品牌",
    OrderTableDescription: "产品描述",
    OrderTableWeight: "重量",
    OrderTableQty: "数量",
    OrderTableQty1: "待采购数量",
    OrderTablePrice: "销售价",
    OrderTableProfit: "利润率",
    OrderTableCost: "成本",
    OrderTableLeading: "交期",
    OrderTableCondition: "货况",
    OrderTableDeclareAmount: "申报金额",
    OrderTableDeclareName: "申报产品名",
    OrderTableDeclareInfo: "申报信息",
    OrderTableDeclarePrice: "申报价格",
    OrderTableAllotmentQty: '已分配数量',
    OrderTablePartialQty: '部分分配数量',
    OrderTableAlreadyOrderedQty: '已订货数量',
    OrderTableShippedQty: '已发货数量',
    OrderTablePartialShipmentQty: '部分发货数量',


    OrderDiscount: "订单折扣",
    OrderShippingCost: "运输费用",
    OrderPaymentFee: "手续费用",
    OrderTax: "关税费用",
    GrandTotal: "订单总价",
    SubTotal: "产品总价",

    OrderVendor: "供应商",
    OrderContact: "联系人",
    OrderPay: "支付",
    OrderPayment: "支付银行",
    OrderNewPayment: "新增银行",
    OrderPayment1: "支付",
    OrderPayBank: '支付银行',
    OrderCurrency: "货币",
    OrderRate: "汇率",
    OrderPayInfo: "支付信息",
    OrderAddress: '地址',
    OrderBuyer: '采购方',
    OrderSelect: '请选择',
    OrderEnter: '请输入',
    OrderSave: '保存',
    OrderCancel: '取消',
    OrderDelete: '删除',
    OrderOutput: '导出',
    OrderSaveandNew: '保存并新增',

    OrderTotalAmount: '总金额',
    OrderTotalDeclareAmount: '申报总金额',
    OrderFullOrder: "全部订货",
    OrderPartialOrder: "部分订货",
    OrderFullDelivery: "全部发货",
    OrderPartialDelivery: "部分发货",

    OrderChartPurchase: "采购价",
    OrderChartPurchase1: "采购价",
    OrderChartSales: "销售价",
    OrderChartSales1: "销售价",
    OrderChartMon: "周一",
    OrderChartTue: "周二",
    OrderChartWed: "周三",
    OrderChartThu: "周四",
    OrderChartFri: "周五",
    OrderChartSat: "周六",
    OrderChartSun: "周日",

    OrderExpenditureRecord: '支出记录',
    OrderPaymentRecords: '收款记录',

    PorderPurchaser: '采购',
    PorderSuppliers: '供应商',
    PorderCreatedBy: '创建者',
    PorderAllocate: '调配任务',
    PorderInventory: '库存',
    PorderAvailable: '可用库存',
    PorderOccupy: '占用库存',
    PorderAllocatePurchaser: '分配采购',
    PorderAllocateQty: '分配数量',
    PorderAlterCost: '更改采购价',
    SorderID: '销售单',
    PorderToal: '总金额',
    PorderStock: '库存',
    PorderPurchaseQty: '采购数量',
    PorderPurchaseTotal: '采购总价',
    PorderStockQty: '库存取用数',
    PorderStockPrice: '库存价格',
    PorderInventoryProfit: '库存利润',
    PorderAction: '操作',
    PorderInputPrice: '库存价',
    ReverseMonthly: '撤销月结算',
    ReverseSettlement: '撤销结算ID',
    ReverseOrders: '撤销结算订单',
    orderYes: '保存',
    orderGrossProfit: '总利润',
    orderMonth: '月份',
    orderYear: '年份',
    orderSettlementID: '结算 ID',
    orderEarliestOrder: '最早单',
    orderLastOrder: '最晚单',
    orderTotalIncome: '总收入',
    orderTotalExpenditure: '总支出',
    orderProfit: '利润',
    orderProfitIs: '利润是',
    orderCreationTime: '创建时间',
    order_Remarks: '订单备注',
    orderWay: '支付方式',
    orderPaied: '金额',
    orderReceiveTime: '时间',
    orderPaymentType: '支付类别',
    orderReceivedRate: '汇率',
    orderSaleType: '类别',
    orderSaleAmount: '金额',
    orderSaleCreator: '创建人',
    orderSaleCreationDate: '创建时间',
    orderStage: '阶段',
    orderUpdatedBy: '更新人',
    orderUpdatedDate: '更新日期',
    orderTableDiscount: '折扣',
    orderTableTax: '税费',
    orderTableTotal: '总价',
    orderTips: '提示',
    orderApprover: '确定批准这个订单?',
    orderTipsInfo1: `1.订单批准后产品项信息不能编辑;\n2.批准后，您可以添加、编辑或删除新添加的型号\n3.批准后，供应商将在系统中收到订单信息。`,
    orderTraded: '确定成交这个订单?',
    orderTipsInfo3: `订单状态更改为“已成交”之后，您可以添加、编辑或删除新添加的型号。`,
    orderCancelled: '确定取消这个订单?',
    orderTipsInfo4: `订单状态更改为“取消”之后，您可以添加、编辑或删除新添加的型号。`,
    orderTipsNo: '取消',
    orderTipsYes: '确定',
    orderBrief: '简要',
    orderItems: '项目',
    orderDetail: '详情',
    orderStart: '开始',
    orderClosing: '关闭',
    orderFee: '费用',
    orderHistory: '历史记录',
    orderPayRef: '支付',
    orderAfterSale: '售后',
    orderSlack: '会话',
    orderBriefInformation: '简要信息',
    orderShopingInformation: '购买信息',
    orderCRMInformation: '系统信息',
    orderOriginalOrder: '原始订单',
    orderOriginal: '原始',
    orderCreateSalesOrder: '创建销售订单',
    orderItemsInformation: '项目信息',
    orderSelectTheContacts: '选择联系人',
    orderSelectTheAddress: '选择地址',
    orderSelectTheVendor: '选择供应商',
    orderSelectTheCurrency: '选择货币',
    orderRATE: '汇率',
    orderSelectThePayment: '选择付款方式',
    orderSelectTheBank: '选择银行',
    orderEditSalesOrder: '编辑销售订单',
    orderSelectThePurchaser1: '选择采购',
    orderFromSalesOrder: '来自销售订单',
    orderFromPurchaseOrder: '来自采购订单',
    orderSelectTheOrder: '选择订单',
    orderAvailable: '可选',
    orderSeletedItems: '选中项目',
    orderSelected: '已选',
    orderFromContactsQTN: "来自联系人报价",
    orderSelectTheContactsQTN: "选择联系人报价",
    orderSelectContact: '选择联系人',
    orderSelectCountry: '选择国家/地区',
    orderSelectType: '选择类型',
    orderSelectTypeOrder: '选择类别',
    orderSelectStatus: '选择状态',
    orderSelectModel: '选择产品',
    orderSelectBuyer: '选择采购方',
    orderStartDate: '开始时间',
    orderEndDate: '结束时间',
    orderDateTo: '至',
    orderKeyWords: '关键字',
    orderFromContact1: '来自联系人',
    orderPast7Days: '过去7天',
    orderPast30Days: '过去30天',
    orderPast90Days: '过去90天',
    orderPurchaserTasks: '采购任务',
    orderSearchTakeList: '搜索采购任务列表',
    orderSelectSales: '选择销售',
    orderSelectPurchasers: '选择采购',
    orderPurchaserOrders: '采购订单',
    orderSearchPurOrderList: '搜索采购订单列表',
    orderCreatePurchaseOrder: '创建采购订单',
    orderConfirm: '确认',
    orderInventoryPrice: '库存价',
    orderInventoryQty: '走库存数',
    orderPurchasePice: '采购价',
    orderAccess: '取用数',
    orderTaskItems: '采购任务项',
    orderPurchaserOrdersItems: '采购订单项',
    orderAllPurchase: '全部采购',
    orderAllSale: '全部销售',
    orderAllVendor: '全部供应商',
    orderSpec: '规格',
    orderSettledList: '结算订单列表',
    orderSettledOrders: '结算明细',
    orderMonthlyProfit: '月份利润',
    orderSettlementIDProfit: '结算ID利润',
    orderReverse: '撤销',
    orderPIName: '单号',
    orderLoading: '加载中...',
    orderSalesOrders: '销售单',
    orderAll: '所有',
    orderMy: '我的',
    orderGrossProfit: '总利润',
    orderMyUnsettledOrders: '我的未结算订单',
    orderMySettledOrders: '我的已结算订单',

    orderFromErrorInfo: '请确保录入的信息完整且格式准确',
    orderNopermission: '没有权限,请联系管理员',
    orderDelInfo: '确定要删除选中的数据?',
    orderPlaceSelectStatus: '请选择状态',
    orderProductDelete: '请选择要删除的产品',
    orderStatusSeleted: "该状态不可选中",
    orderNewAddress: "新增地址",
    orderMarked: "标记为当前阶段",
    orderNoItems: "未选择Items",
    orderSelectItem: "从Items选择一项,开始使用",
    orderReverseMonthly: '确定要撤销结算选中的月结单?',
    orderReverseMonthlyItem: '确定要撤销结算这个月结单?',
    orderReverseSettlement: '确定要撤销选中的结算ID?',
    orderReverseSettlementItem: '确定要撤销这个结算ID?',
    orderReverOrder: '确定要撤销结算选中的订单?',
    orderReverOrderItem: '确定要撤销结算这个订单?',
    orderSelectCopyProduct: '请选择要复制的产品',
    orderSelectDeleteProduct: '请选择要删除的产品',
    orderAgainSubmit: '请勿重复提交',
    orderPleaseAddData: '请添加数据',
    orderSelectShipOrder: '请选择要发货的订单',
    orderLockedDeleted: '订单已锁定,无法删除',
    orderReplication: '复制成功',
    orderPleaseSelectPurchaseOrder: '请选择要删除的采购订单',
    orderPleasePurchaseTask: '请选择要删除的采购任务',
    orderEnterQuantityPrice: '输入库存数量获取均价',
    orderPleaseNumber: '输入取用数',
    orderInventoryQtyAccessQty: "取用数总和与走库存数不匹配",
    orderAvailablePurchase: '本批次暂无可采购数量',
    orderSureReturn: '确定退回所选产品?',
    orderSureDistribute: '确定分配所选产品?',
    orderSureDeleteProduct: '确定删除所选产品?',
    orderAccurate: '请确保价格已重新录入且格式准确',
    orderChangeProduct: '确定更改所选产品价格?',
    orderPleaseEnterTask: '请选择要录入的采购任务',
    orderTaskReassigned: '该任务已在采购中,不支持重新分配',
    orderSelectAssigned: '请选择要分配的产品',
    orderAllocationSuccess: '分配成功',
    orderProcurementReturnable: '该采购任务已在采购中,没有可退回的任务数量',
    orderPleaseProductReturn: '请选择要退回的产品',
    orderReturnSuccessful: '退回成功',
    orderPleaseChangedPrice: '请选择更改价格的产品',
    orderChangesuccessfully: '更改成功',
    orderPurchaseCannotDeleted: '该采购订单已付款，不支持删除',
    orderPleaseDeleteProduct: '请选择要删除的产品',
    orderSuccessfullyDeleted: '删除成功',
    orderSelectDelData: '请选择要删除的数据',
    orderEnterOnlyTwo: '仅限输入小数点后两位',
    orderGreaterCannot: '输入数据不能大于',
    orderSureSett: '确定要结算选中的订单 ?',
    orderTips: '温馨提示',
    orderNewInformation: '新建的信息尚未保存,确定离开吗 ?',
    orderEditInformation: '编辑的信息尚未保存,确定离开吗 ?',
    orderInformation: '信息尚未保存,确定离开吗 ?',
    orderConfirm: "确定",
    orderCancel: "取消",
    orderSelectContactPI: "选择联系人获取PI",
    orderPleaseAmount: '请输入金额',
    orderCommission: '佣金单',
    orderRelatedPI: '相关订单',
    orderUndertaker: '承担人',
    orderPleasePI: '请选择订单获取PI',
    orderPreviousAmount: '更改前价格',
    orderUpdatedAmount: '更改后价格',
    orderUpdater: '更改人',
    orderUpdatedDate1: '更改时间',
    orderTypeOrder: '订单类别', //订单类型
    orderSalesOrderNormal: '普通订单',
    orderCommissionSalesOrder: '佣金单',
    orderAftersaleReshipment: '售后补发单',
    CreateNewOrder: '创建订单',
    orderNextStep: '下一步',
    CreateCommissionSalesOrder: '创建佣金单',
    CreateAftersalesReshipmentOrder: '创建售后补发单',
    OrderFee: '费用记录',
    EditCommissionSalesOrder: '编辑佣金单',
    EditAftersalesReshipmentOrder: '编辑售后补发单',
    RelateAfterSalesReshipmentOrder: '相关售后补发单',
    ROrder: '补发单',
    RelateSalesOrder: '相关销售单',
    OrderType1: '类别',
    InputDataCannot: '输入数据不能大于',
    EnterSubject: '输入主题',
    SelectTheCarrier: '选择运输方式',
    SelectThePurOrder: '选择采购单',
    ProductionDate: '生产日期',
    FreightSpace: '货位',
    EditPurchaseOrder: '编辑采购单',
    PurchaseOrders: '采购单',
    PurOrderLogs: '日志',
    PurOperator: '操作人',
    PurOperationTime: '操作时间',
    OperationContent: '操作内容',
    PurActionInfo1: '成本价从',
    PurActionInfo2: '更改成',
    PurchaserOrdersLog: '采购单日志',
    SurfaceMail: '平邮',
    Register: '挂号',
    EMSExpress: 'EMS快递',
    FederalExpress: '联邦快递',
    UPSExpress: 'UPS快递',
    OrderCity: '城市',
    OrderZip: '邮编',
    OrderBankName: '银行名称',
    OrderDepositBank: '存款银行',
    OrderBankAccount: '银行账户',
    OrderBalance: '账户余额',
    OrderCompany: '公司',
    OrderNoncollectableCountries: '不适用国家',
    AddToOrder: '添加到订单',
    NewOrder: '新建订单',
    VendorContanct: '供应商联系人',
    orderSetDiscount: '设置折扣',
    orderDiscountPercentage: '折扣比例',
    orderDirectReduction: '直接输入折扣',
    orderSetTax: '设置税收',
    orderConsumptionTax: '消费税',
    orderValueAddedTax: '增值税',
    orderTariff: '关税',
    orderTotal: '总额',
    orderExactSearch: '精确搜索',
    orderReset: '重置',
    orderSearch: '搜索',
    orderFollowingCancelled: '以下结算单已取消结算',
    orderOrderCreated: '创建订单',
    PurchaseOrderCreated: '创建采购订单',
    orderIsLocked: '该订单被锁定，不能删除',
    OerderWarningDel: "确定删除此订单?",
    OrderNchanged: '数据没有改动',
    SettlementSuccessful: '结算成功',
    Source: '来源',
    SelectTheSources: '选择来源',
    ContactOwner: '联系人Owner',
    SelectTheContactOwner: '选择联系人Owner',
    orderFrom: '来自',
    orderClose: '关闭',
    TotalRevenue: '总收款',
    TotalExpenses: '总支出',
    TotalProfit: '总利润',
    SupplySource: '货源',
    AddNewProduct: '新增产品',
    ProductName: '产品名称',
    DescriptionName: '描述名称',
    Description: '描述',
    Language: '语言',
    Commission: '佣金',
    OrderNoData: '暂无数据',
    OrderProfit: '订单利润',
    Account: '客户',
    ProductProfit: '产品利润',
  },
  Warning: {
    // 订单财务
    OrderWarning: "警告",
    OrderWarningCancel: "取消",
    OrderWarningOK: "确定",
  },
  success: {
    OrderSaveSuccess: "保存成功",
    OrderAddedSuccess: "新增成功",
    OrederDeletedSuccess: "删除成功",
    OrderSuccessSuccessPlaceAnOrder: "订货成功",
    OrderSuccessDelivery: "发货成功",
    PurchaseOrderSuccessDeployment: "调配成功",
    PurchaseOrderSuccessfulReturn: "退回成功",
    PurchaseOrderSuccessChange: "更改成功",
    PaymentAuditSuccess: "审核成功",
    SubmissionSuccessful: "提交成功",
    WithdrawalSuccessful: "撤回成功",
    RejectionSuccessful: "驳回成功",
  },
  /**询盘**/
  rfq: {
    warning: "警告",
    newWarning: "新建将导致未保存的数据丢失。是否保存并新建?",
    noSave: "无需保存",
    new: "新建",
    cancelNew: "取消新建",
    save: "保存",
    addOrder: "添加到订单",
    addQuotation: "添加到报价",
    delete: "删除",
    multipleBuyer: "多个采购",
    quoter: "报价人",
    operation: "操作",
    rfqId: "询盘 ID",
    cnty: "国家/地区",
    items: "项目",
    supplier: "供应商",
    status: "状态",
    add: "添加",
    savePrompt: "请先选择型号和品牌",
    saveSuccess: "保存成功",
    delSuccess: "删除成功",
    deleteWarning: "确定要删除吗?",
    historicalInquiry: "历史询盘",
    historicalQuote: "历史报价",
    fromRfq: "来自询盘",
    excel: "导出",
    historicalDeal: "历史成交价",
    rfqList: "询盘列表",
    qtnList: "报价列表",
    chooseTheOrder: "请选择订单",
    toQuote: "向报价添加项目",
    batchProfit: "批量更改利润",
    batchDeliveryDate: "批量更改交期",
    pleaseInquiry: "请选择询盘",
    pleaseOrder: "请选择订单",
    leading1: "一周有效",
    leading2: "三个月有效",
    leading3: "今天有效",
    leading4: "三天有效",
    leading5: "五天有效",
    leading6: "一个月有效",
    leading7: "半年有效",
    condition1: "QB全新保内",
    condition2: "QG全新过保",
    condition3: "QK全新开封保内",
    condition4: "QKG全新开封过保",
    condition5: "F翻新",
    condition6: "E二手",
    condition7: "J兼容",
    condition8: "G高仿无牌",
    condition9: "GD高仿带牌",
    condition10: "S升级",
    condition11: "W无货",
    exportWarning: "请先选择一条报价",
    draft: "草稿",
    quoting: "报价中",
    Quoted: "已报价",
    pending: "待报价",
    salesRecord: "销售已录",
    purchaserRecord: "采购已报价",
    contactsQtn: "已报价",
    completedUnread: "完成未阅",
    completed: "已完成",
    read: "已阅",
    sendQtn: "发送报价",
    browser: "浏览器版本过低，请升级",
    notSelected: "未选择项目",
    selectAnItem: "从项目中选择一项，以开始使用。",
    contact: "联系人",
    accout: "客户",
    saveAndNew: "保存并新建",
    cancelTheNew: "取消新建",
    text: "文本",
    allStatuses: "所有",
    checkWant: "选择需要导出的内容",
    replicated: "已复制",
    tips: "温馨提示",
    editedInformation: "编辑的信息尚未保存 确定离开吗？",
    clipboard: "剪切板",
    PleaseSelectInquiry: "请选择需要操作的询盘",
    formatError: "格式错误",
    dataError: "该型号不存在，请先录入型号库再添加",
    pasteSuccessful: "粘贴成功",
    ensureThat: "请确保输入的信息完整且格式准确",
    paste: "快捷粘贴",
    pleasePaste: "请粘贴",
    copySpecification: "复制规格：型号 x 数量，案例：PC/MPI x 12。",
    copyingTheModel:
      "复制型号+数量后，点击【快捷粘贴】操作，可快捷创建对应的Items数据。",
    multipleModels: "多个型号用回车键换行。",
    orderFirst: "请先选择一个现有的订单",
    QTNFirst: "请先选择一个现有的QTN",
    cannotBe0: "价格不能为0",
    maxQty: "数量上限999999",
    maxCost: "成本上限9999999999.99",
    maxRrice: "价格上限9999999999.99",
    maxProfit: "利润上限9999999999.99",
    accurate: "请输入正数或零，精确至小数点后两位",
    vendor: "供应商",
    submitToQtn: "提交到报价",
    submitToVendo: "提交到供应商",
    addToQtn: "添加到报价",
    listPrice: "销售单价",
    amount: "总价格",
    send: "发送",
    arrivalTime: "到货时间",
    selectCountry: "请选择国家",
    Creator: "创建人",
    allContacts: "所有联系人",
    allCountrys: "所有国家/地区",
    selectTheModel: "选择型号",
    start: "开始时间",
    closing: "结束时间",
    items: "项目",
    teamItem: "团队项目",
    creationDate: "创建日期",
    originalRfq: "原始询盘",
    cancel: "取消",
    confirm: "确定",
    createNewRfq: "创建新询盘",
    resubmit: "请勿重复提交",
    briefInformation: "简要信息",
    itemsInformation: "项目信息",
    cannotBeEmpty: "项目不能为空。",
    astp: "提交后，采购可对该询盘的型号进行报价。",
    astpVendor: "提交后，供应商可以为您进行审查和报价。",
    Submit: "提交",
    submitTo: "提交到",
    purchaser: "采购",
    qtn: "报价",
    purchaseQtn: "相关采购报价",
    fromPurchaseQtn: "从采购报价添加",
    quoteToSales: "给销售报价",
    quoteToContacts: "给联系人报价",
    sendTheQtnSales: "您确定要将报价发送给销售人员吗？",
    sendTheQtnContact: "您确定要将报价发送给联系人吗？",
    send: "发送",
    SendQuote: "发送报价",
    historyQTN: "历史报价",
    historyDealValence: "历史成交价",
    NoItemsSelected: "未选择任何项目",
    SelectNnItemFrom: "从“项目”中选择一个项目以开始使用。",
    SelectTheRFQ: "选择询盘",
    Available: "可选项",
    SelectedItems: "选择项目",
    QuicklyAddQTN: "将报价快捷添加到询盘",
    ThePublicRFQ: "公开询盘",
    PublicRFQ: "公开询盘",
    PersonalRFQ: "个人询盘",
    AvailableItems: "可选项目",
    myQTN: "我的报价",
    AddToOrder: "添加到订单",
    QuicklyAddRFQ: "将询盘快捷添加到订单",
    SelectExistingOrder: "选择现有订单",
    Selected: "已选择",
    RelatedQTN: "相关报价",
    RelatedContactsQTN: "相关联系人的报价",
    Sales: "销售",
    CreateNewOrder: "创建新的订单",
    // ListPrice: "单价",
    SelectTheCurrency: "选择货币",
    SelectTheProfit: "选择利润",
    KeyWords: "关键词",
    noDataToSubmit: "暂无提交数据",
    networkError: "网络出错啦",
    submitted: "已提交",
    modelToBeQuoted: "请先选择需报价的型号",
    hasBeenSelected: "已选择该询盘，不能重复添加",
    alreadyExists: "已存在",
    selectTheVendor: "选择供应商",
    selectThePurchaser: "选择采购",
    pleaseSelectRFQ: "请选择询盘",
    ModifiedSuccessfully: "修改成功",
    NoData: "暂无数据",
    submitToVendor: "提交到供应商",
    addToPurchaseOrder: "添加到采购订单",
    selectTheVendorAndRFQ: "选择供应商和询盘",
    spec: "规格",
    allVendor: "全部供应商",
    pleaseselectInquiry: "请选择询盘",
    submitToContact: "提交到联系人",
    addToSalesOrder: "添加到销售订单",
    selectPurchaser: "选择采购",
    replicatingSuccess: "复制成功",
    noData: "暂无数据",
    select: "选择",
    selectTheCountry: "选择国家/地区",
    selectTheAccount: "选择客户",
    startDate: "开始时间",
    endDate: "结束时间",
    selectTheModel: "选择型号",
    search: "搜索",
    reset: "重置",
    exactSearch: "精确搜索",
    my: '我的',
    all: '所有',
    publicRFQ: '公开询盘',
    personalRFQ: '个人询盘',
    myRFQ: '我的询盘',
    contactsRFQ: '联系人询盘',
    myQTN: '我的报价',
    PurchaseQTN: '采购报价',
    ContactsQTN: '联系人报价',
    RFQ: '询盘',
    QTN: '报价',
    PleaseChoose: '请选择',
    PleaseselectContact: '请选择联系人',
    PleaseselectOwner: '请选择Owner',
    PleaseselectSupplier: '请选择供应商',
    InStock: '是否有货',
    OutStock: '无货',
    yesAvailable: '有货',
    OutOfStock: '批量无货',
    averagePrice: '平均价格',
    myPrice: '我的报价',
    source: '来源',
    RFQCreated: '询盘已创建',
    PleaseSelectOperatedData: '请先选择需要操作的数据',
    allBrands: '所有品牌',
    rfqId: '询盘ID',
    PleaseSelectRfqID: '请选择询盘ID',
    orderID: '订单ID',
    PleaseSelectOrderID: '请选择订单ID',
    quotedIsNotSupportedDeletion: '该型号已报价，不支持删除',
    AllVendors: '所有供应商',
    AllConditions: '所有货况',
    maxPrice: '最高价',
    minPrice: '最低价',
    creationTime: '创建日期',
    models: '型号',
    action: '操作',
    targetedRfq: '定向询盘',
    AddNewProduct: '新增产品',
    PublicScope: '公开范围',
    AllPlatformVendors: '平台所有供应商',
    MyVendors: '我的供应商',
    QrganizationVendors: '本组织所有供应商',
    Description: '描述',
    EnterTheDescription: '输入描述',
    ModelsSubmitted: '型号已提交',
    AllPrices: '所有价格',
    Favorite: '已收藏',
    Canceled: '已取消',
    detail: '详情',
    added: '已添加',
    SaveTheError: '保存失败',
    ItemsCannotEmpty: '项目不能为空',
    AllPublicScope: '所有公开范围',
    To: '至',
    LastWeek: '上个星期',
    LastMonth: '上个月',
    Last3Months: '最近3个月',
    OutOfStockNotAddition: '无货不支持添加',
    enter: '请输入',
    Tips: '提示',
    MSG: '消息',
    RelatedRFQ: '相关询盘',

  },
  /**报价 */
  qtn: {
    CreateNewQTN: "创建新的报价",
    SynchronizedRFQ: "同步询盘",
    ItemsInformation: "项目信息",
    RelatedPersonalRFQ: "相关个人询盘",
    RelatedPublicRFQ: "相关公开询盘",
    RelatedMyRFQ: "相关我的询盘",
    sendTheQuotationToTheSupplier: "确定要将报价发送给供应商吗?",
    RelatedContactsRfq: "相关联系人询盘",
    addtoSalesOrder: "添加到销售订单",
    PleaseSelectRFQ: '请选择询盘'
  },
  /*公用*/
  com: {
    id: 'ID',
    add: '新增',
    new: '新建',
    edit: '编辑',
    confirm: '确定',
    Submit: '提交',
    close: "关闭",
    saveAndNew: '保存并新建',
    save: "保存",
    cancel: "取消",
    reset: '重置',
    del: '删除',
    print: '打印',
    yes: '是',
    no: '否',
    Loading: '加载...',
    noMore: '没有更多了',
    noData: '暂无数据',
    information: '信息',
    index: '序号',
    select: '请选择',
    enter: '请输入',
    enterTowDecimal: '请输入零或正数且最多两位小数',
    integer100_en: '请输入0~100的整数',
    letterNum_en: '请输入字母和数字',
    searchMember: '搜索成员',
    search: '搜索',
    dateFormat: 'YYYY/MM/DD',
    timeFormat: 'YYYY/MM/DD HH:mm:ss',
    minuteFormat: 'YYYY/MM/DD HH:mm',
    startPlaceholder: '开始时间',
    To: '至',
    endPlaceholder: '结束时间',
    copySuccess: '复制成功',
    copyError: '复制失败',
    delSuccess: '删除成功',
    delError: '删除失败',
    addSuccess: '新增成功',
    addError: '新增失败',
    editSuccess: '编辑成功',
    editError: '编辑失败',
    saveSuccess: '保存成功',
    saveError: '保存失败',
    handleSuccess: '操作成功',
    handleError: '操作失败',
    serverError: '服务器错误，请重试',
    networkError: '请检查网络',
    checkData: '请先勾选数据',
    aHour: '一个小时过期',
    aWeek: '一个星期过期',
    aMoom: '一个月过期',
    aHalfYear: '半年过期',
    aYear: '一年过期',
    FileSharing: "文件分享",
    fileName: "文件名",
    password: "密码",
    noPassword: "无需密码",
    yesPassword: "通过密码分享",
    expirationTime: "到期时间",
    createLink: "创建链接",
    passwordError: "密码错误",
    EenterPwd: '请输入密码',
    linkTime: '链接已过期',
    link: '链接',
    creationDate: '创建时间',
    keyWords: '关键词',
    Email: '邮箱',
    Email_en: '请输入邮箱',
    Email_en1: '请输入正确邮箱',
    exactSearch: '精准搜索',
    notSelected: '未选择items',
    selectAnItem: '从Items选择一项，以开始使用。',
    NotExp: '暂无数据可导出！',
    action: "操作",
    import: '导入',
    export: '导出',
    setting: '设置',
    details: '详情',
    type: '类型',
    size: "尺寸",
    length: '长',
    width: '宽',
    height: '高',
    weight: '重',
    diameter: '直径',
    creator: "创建人",

    //All
    allCountries: '全部国家或地区',
    allCities: '全部城市',
    allStatus: '全部状态',
    allTypes: '全部类型',
    allVendors: '全部供应商',
    allContacts: '全部联系人',
    allCreators: '全部创建人',
    allModels: '全部产品型号',
    allAccounts: '全部客户',
    allWays: '全部方式',
    allStages: '全部阶段',
    allPredictionTypes: '全部预测类别',
    allSources: '全部来源',
    allProducts: '全部产品',
    allBrands: '全部品牌',
    //常用
    All: '所有',
    My: '我的',
    RFQ: '询盘',
    QTN: '报价',
    QTY: '数量',
    model: '型号',
    Stage: '阶段',
    Detail: '详情',
    History: '历史',
    ActionLogs: '操作记录',
    MSG: 'MSG',//不转中文
    Selected: '已选',
    Time: '时间',
    Days: '天',
    Months: '月',
    once: '单次',
    circulate: '循环',
    owner: 'Owner',
    vendor: '供应商',
    country: "国家/地区",
    country_se: '请选择国家/地区',
    resTime: '请求超时，请检查网络！',
    res404: '网络请求不存在！',
    res500: '服务器内部错误！',
    resOther: '发生未知异常，，异常信息：',
    markReadFailed: '标记已读失败！',
    contact: "联系人",
    account: '客户',
    account_se: '请选择客户',
    contact_se: '请选择联系人',
    city: '城市',
    city_en: '请输入城市',
    zip: '邮编',
    zip_en: "请输入邮编",
    street: '街道门牌号',
    street_en: '请输入街道门牌号',
    description: '描述',
    description_en: '请输入描述',

  },
  /** 设置 */
  setting: {
    department: "部门",
    userGroup: "用户组",
    operate: "操作",
    edit: "编辑",
    editPermissions: "编辑权限",
    showAll: "全部显示",
    disableAll: "全部禁用",
    cancel: "取消",
    determine: "确定",
    changePassword: "修改密码",
    oldPassword: "旧密码",
    password: "新密码",
    confirmPassword: "确认密码",
    exit: "退出",
    edit: "编辑",
    signIn: "登录",
    Registration: "注册",
    name: "名 字:",
    phone: "电 话:",
    mailbox: "邮 箱:",
    sex: "性 别:",
    pass: "密 码:",
    welcome: "欢迎注册",
    personal: "个人资料",
    userName: "用户名",
    gender: "性别",
    phone: "电话",
    country: "国家",
    pas: "密码",
    modify: "修改",
    myAvatar: "我的头像",
    male: "男",
    female: "女",
    currency: "选择币种",
    langue: "切换语言",
    theRoleName: "请输入角色名",
    deleteSuccessful: "删除成功",
    removeTheMember: "请先移除成员",
    modificationFailed: "修改失败",
    searchUserName: "搜索成员用户名|手机号|部门",
    userToBeRemoved: "请选择需移除的用户",
  },
  //售后
  AfterSale: {
    AfterSale: '售后',
    AfterSaleOrder: '售后单',
    All: '所有',
    My: '我的',
    PleaseChooseAndCheckItems: '请选择需要退款的型号',
    SaveSuccess: "保存成功",
    OrderNoAfterSale: '该订单还不能新建售后',
    Commission: '佣金',
    Responsible: '责任人',
    VendorContact: '供应商联系人',
    AccountContact: '客户联系人',
    Search_AllCountries: "全部国家或地区",
    Search_AllContacts: "全部联系人",
    Search_AllStatus: "全部状态",
    Search_Models: "输入型号名称",
    Search_AllKeyword: "Owner/创建人名称/售后编号/订单编号",
    placeholderContacts: "联系人",
    placeholderVendor: "供应商",
    placeholderStatus: "状态",
    StartDate: "开始日期",
    EndDate: "结束日期",
    NewAfterSale: "新建售后单",
    EditAfterSale: "编辑售后单",
    SelectTheType: "选择售后类型",
    OrderInformation: "订单信息",
    PleaseSelectOrder: "请选择订单编号",
    Remarks: "备注",
    BankSlip: "银行水单",
    Purchase: "采购",
    Sale: "销售",
    PurchaseOrder: "采购订单",
    SaleOrder: "销售订单",
    Refunds: "仅退款",
    ReturnsandRefunds: "退货且退款",
    ReturnsandRefundsInformation: "退货和退款信息",
    Type: "类型",
    //售后列表
    SaleList_OrderType: "订单类型",
    SaleList_AfterSaleType: "售后类型",
    SaleList_OrderId: "订单ID",
    SaleList_Status: "状态",
    SaleList_Creator: "创建人名称",
    SaleList_CreationDate: "创建时间",
    SaleList_Action: "操作",

    //操作按钮
    Salebtn_New: "新建",
    Salebtn_Edit: "编辑",
    Salebtn_Submit: "提交",
    Salebtn_Delete: "删除",
    Salebtn_Details: "详情",
    Salebtn_Save: "保存",
    Salebtn_Cancel: "取消",
    Salebtn_Close: "关闭",
    //明细列表
    Details_Model: "型号",
    Details_Pi: "订单编号",
    Details_Brand: "品牌",
    Details_Condtion: "货况",
    Details_Leading: "交期",
    Details_Qty: "总数量",
    Details_Cost: "成本",
    Details_Price: "售价",
    Details_Profit: "利润",
    Details_DiscountPrice: "订单折扣",
    Details_Tax: "税费",
    Details_Total: "总金额",
    Details_ListCost: "成本价",
    Details_ListPrice: "售价",
    Details_ReturnedQuantity: "已退货数量",
    Details_AmountRefunded: "已退金额",
    Details_QuantityReturned: "本次退货数量",
    Details_RefundAmount: "本次退款金额",
    Details_scale: "本次比例",
    Details_NegativeProfit: "总负利润",
    Details_TotalRefund: "总退款",

    // 采购订单详细
    Details_QuantityInStorage: "已入库数量",
    Details_QuantityOfThisStorage: "本次入库数量",
    Details_NegativeProfitThisTime: "本次负利润",

    //提交售后
    Submit_Title: "确定要提交售后订单吗?",
    Submit_Tips: "提示：",
    Submit_Commit1: "1.提交后不能编辑;",
    Submit_Commit2: "2.财务会根据售后订单进行退款。",
    Submit_Scccessful: "售后单提交成功",
    //删除售后
    deleteSale_message: "确定要删除该售后单吗?",
    deleteSale_Scccessful: "成功删除售后单",

    //验证信息
    refund_quantityPlease: "请填写退货数量",
    refund_quantityMessage: "退货数量不可超过剩余可退数量",
    refund_amountPlease: "请填写退款金额",
    refund_amountMessage: "退货金额不可超过剩余可退金额",
    warehouse_numberPlease: "请填写本次入库数量",
    warehouse_numberMessage: "入库数量不可超过剩余可入库数量",

    Fee: "费用",
    PaymentFee: "手续费用",
    ShippingCost: "运输费用",
    SubTotal: "产品总价",
    GrandTotal: "订单总价",
    AmountPayable: "应付金额",
    AmountPaid: "已付金额",
    AmountRefunded: "已退金额",
    GrossProfit: "总利润",
    NegativeProfit: "负利润",
    Draft: "草稿",
    PendingRefund: "待退款",
    PartRefunded: "部分退款",
    Refunded: "已退款",
    Specs: "规格",
    Search: '搜索',
    Select: '请选择',
    AfterSalesTypeTip: '请选择售后类型',
    OrderTypeTip: '请选择订单类型',
    OrderNumberTip: '请选择订单',
  },

  slack: {
    channel: "频道",
    createChannel: "创建频道",
    privateLetter: "私信",
    addFriends: "添加好友",
    description: "说明",
    createUser: "创建者",
    exit: "退出",
    remove: "移除",
    newMessage: "新消息",
    message: "消息",
    file: "文件",
    personnel: "人员",
    keywords: "关键字",
    from: "来自",
    to: "在",
    in: "与",
    view: "您当前正在查看",
    Channelname: "频道名称",
    Rename: "重命名此频道",
    Starred: "星标",
    Sales: "销售",
    Contacts: "联系人",
    CreatedBy: "创建者",
    Draft: "草稿",
    Quoting: "已提交到报价",
    PurchaseRecorded: "采购已报价",
    SalesRecorded: "完成未阅",
    Completed: "完成",
    Pending: "采购未提交报价",
    Models: "型号",
    Model: "型号",
    RelatedPurchaseQTN: "采购报价",
    RelatedContactQTN: "联系人报价",
    Brand: "品牌",
    Condition: "货况",
    Leading: "交期",
    Cost: "成本",
    Price: "销售价",
    Quotedby: "采购",
    Purchaser: "采购",
    Vendor: "供应商",
    VendorContacts: "供应商联系人",
    RelatedRFQ: "相关询盘",
    PurchaseQTN: "采购报价",
    ContactQTN: "联系人报价",
    ContactRFQ: "联系人询盘",
    SalesOrders: "销售订单",
    Itmes: "项目",
    RelatedQTN: "相关报价",
    Fee: "费用",
    Discount: "折扣",
    PaymentFee: "手续费用",
    ShippingCost: "运输费用",
    Tax: "关税费用",
    SubTotal: "产品总价",
    GrandTotal: "订单总价",
    Details: "详情",
    Type: "类型",
    Payment: "支付方式",
    Address: "地址",
    PurchaseTasks: "采购任务",
    PurchaseOrders: "采购订单",
    RelatedPurchaseTasks: "相关采购任务",
    RelatedPurchaseOrders: "相关采购订单",
    Qty: "数量",
    Inventory: "库存",
    ListPrice: "销售价",
    Available: "可用库存",
    Occupy: "占用库存",
    ListCost: "成本",
    Profit: "利润率",
    Total: "总金额",
    RelatedSalesOrder: "相关销售订单",
    Owner: "所属者",
    DealStatus: "交易状态",
    Fax: "传真",
    Website: "网站",
    Name: "名字",
    Phone: "电话",
    Email: "邮箱",
    AddressInformation: "地址信息",
    DescriptionInformation: "描述信息",
    RelatedInformation: "相关信息",
    Account: "账号",
    Level: "等级",
    OtherPhone: "其他电话",
    department: "部门",
    DateOfBrith: "生日",
    Selectobject: "选择对话对象",
    Chatwithcontact: "与联系人聊天",
    Chatwithpurchaser: "与采购聊天",
    Cancel: "取消",
    Next: "下一步",
    Confirm: "提交",
    Create_a_channel: "创建一个频道",
    MessageColumn: "消息列",
    Replies: "条回复",
    createAccount: "联系人尚未创建系统帐户。请先创建一个帐户。",
    Edit: "修改",
    RFQID: "询盘 ID",
    QTNID: "报价 ID",
    OrderID: "订单 ID",
    PurchaseOrderID: "采购订单ID",
    ContactDetails: "联系人详情",
    VendorDetails: "供应商详情",
    RFQ: "询盘",
    QTN: "报价",
    Order: "订单",
    Searchobject: "搜索对话对象",
    adduser: "邀请用户",
    About: "关于",
    Member: "成员",
    delete: "删除",
    ForwardMessage: "转发消息",
    Orders: "订单",
    HistoricalConversations: "历史会话",
    YourChats: '你的聊天',
    Writemessage: "写一条消息",
    Video: "视频",
    voice: "语音",
    Image: "图片",
    Selectobject: "选择一个对话对象",
    LoginText: "登录",
    name: "名称",
    MyRFQtext: "我的询盘",
    MyQTNtext: "我的报价",
    MyOrders: "我的订单",
    CurrentRFQtext: "选中的询盘",
    CurrentQTNtext: "选中的报价",
    CurrentSalestext: "选中的销售订单",
    CurrentPurchasetext: '选中的采购订单',
    source: "来源",
    Countrys: "国家",
    FormText: "类别",
    StatusText: "状态",
    AllRead: "全部已读",
    BasicInformation: "基本信息",
    CountryRegion: "国家/地区",
    DeliveryTime: "发货时间",
    ShippingFee: "运费",
    Way: "运输方式",
    Doc: "原单号",
    AWB: "转单号",
    items: "项目",
    Rate: "汇率",
    Weight: "重量",
    Cartons: "箱数",
    Carton: "箱数编号",
    Size: "尺寸",
    VolumeWeight: "净重",
    GrossWeigh: "毛重",
    PackingPictures: "打包图片",
    Remarks: "备注",
  },
};
